import { Box, FormHelperText, FormLabel, Input, type InputProps } from '@chakra-ui/react';

export const subTextStyles = {
   color: 'gray.500',
   fontSize: '13px',
   sx: {
      textWrap: 'pretty',
   },
} as const;

interface SignUpInputProps {
   field: InputProps;
   label: string;
   helperText?: string;
   id?: string;
   isDisabled?: boolean;
}

export function SignUpInput({
   field,
   label,
   helperText,
   id,
   isDisabled = false,
   ...inputProps
}: SignUpInputProps & InputProps) {
   return (
      <Box>
         <FormLabel htmlFor={id}>{label}</FormLabel>
         <Input id={id} disabled={isDisabled} {...field} {...inputProps} />
         {helperText && <FormHelperText {...subTextStyles}>{helperText}</FormHelperText>}
      </Box>
   );
}
